import { render } from "./StaffDatatableTechnicActions.vue?vue&type=template&id=1e924d3b"
import script from "./StaffDatatableTechnicActions.vue?vue&type=script&lang=js"
export * from "./StaffDatatableTechnicActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__